/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.10.1
 */
import { T as TableCell, d as defineCustomElement$1 } from './table-cell.js';

const CalciteTableCell = TableCell;
const defineCustomElement = defineCustomElement$1;

export { CalciteTableCell, defineCustomElement };

//# sourceMappingURL=calcite-table-cell.js.map